import instance from './base.service';

export const getAccountDetails = async (params) => {
  const { accountId } = params;
  const url = `/dealership-accounts/${accountId}`;

  const response = await instance.get(url);
  return response.data;
};
